export default "__VITE_ASSET__71a6d757__"